import { render, staticRenderFns } from "./SizeChartTypeModal.vue?vue&type=template&id=9b8c56f6&scoped=true&"
import script from "./SizeChartTypeModal.vue?vue&type=script&lang=js&"
export * from "./SizeChartTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./SizeChartTypeModal.vue?vue&type=style&index=0&id=9b8c56f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c56f6",
  null
  
)

export default component.exports